// Central registry of backend routes — aligned with Cloudflare Workers API.
export const ENDPOINTS = {
  user: {
    me:            () => '/api/user/me',
    update:        () => '/api/user/me',
    stats:         () => '/api/user/stats',
    preferences:   () => '/api/user/me',
  },
  scenarios: {
    list:          () => '/api/scenarios',
    detail:        (id) => `/api/scenarios/${id}`,
  },
  session: {
    start:         () => '/api/session/start',
    respond:       () => '/api/session/respond',
  },
  stats: {
    overview:      () => '/api/user/stats',
    deadlines:     () => '/api/user/stats',
    recents:       () => '/api/user/stats',
    performance:   () => '/api/user/stats',
    streak:        () => '/api/user/stats',
  },
  notifications: {
    list:          () => '/notifications',
    markRead:      (id) => `/notifications/${id}/read`,
  },
  bot: {
    send:          () => '/api/bot/chat',
    history:       (scenarioId) => `/api/bot/history${scenarioId ? `?scenario_id=${scenarioId}` : ''}`,
  },
  game: {
    launch:        () => '/api/game/launch',
  },
  files: {
    upload:        () => '/api/files/upload',
  },
};